import {fabric} from "fabric-with-gestures";

export default {
  data() {
    return {
      selectionTables: [],
      availableTableIds: [],
      canvas: null,
    }
  },
  watch: {
    availableTable() {
      this.reRenderCanvas();
    }
  },
  methods: {
    call(o) {
      if (this.selectionTables.indexOf(parseInt(o.target.my.id)) !== -1) {
        this.selectionTables.splice(this.selectionTables.indexOf(parseInt(o.target.my.id)), 1);
        o.target.getObjects().forEach((o) => {

          if (o.my.type == 'table') {
            o.set({
              fill: '#dddddd',
              stroke: '#aaaaaa',
            })
          }
        });
      } else {

        o.target.getObjects().forEach((os) => {

          if (os.my.type == 'table') {
            this.selectionTables.push(parseInt(o.target.my.id));
            os.set({
              fill: '#0080005c',
              stroke: '#0080005c',
            })
          }
        });
      }
      this.canvas.renderAll();
    },
    reRenderCanvas() {
      let objectForFill = [];
      let maxY = 0;
      let maxX = 0;

      this.canvas.loadFromJSON(this.restaurant.schema, () => {
        this.canvas.renderAll();
      }, (o, object) => {


        if (o.my && o.my.id && !(this.availableTableIds.indexOf(parseInt(o.my.id)) !== -1)) {
          object.set(
            {
              width: 0,
              height: 0,
              opacity: 0,
            }
          )
        }

        if (o.my) {
          if (this.selectionTables.indexOf(parseInt(o.my.id)) !== -1) {
            objectForFill.push(object);
          }
          object.on('mouseup', this.call)
        }

        var coords = object.getCoords()
        for (var c in coords) {
          for (var vatt in coords[c]) {
            maxX = maxX >= coords[c].x ? maxX : coords[c].x;
            maxY = maxY >= coords[c].y ? maxY : coords[c].y
          }
        }


        object.set(
          {
            selectable: false,
            hasControls: false,
            hasBorders: false,
            selection: false
          }
        )

      })
      this.canvas.set({
        selectable: false,
        selection: false,
        backgroundColor: '#dddddd2e'
      })
      this.canvas.setHeight(maxY);
      this.canvas.setWidth(maxX);
      this.canvas.renderAll();


      objectForFill.map((item) => {

        item.getObjects().forEach((os) => {
          if(os.my || false){
            if (os.my.type == 'table') {
              os.set({
                fill: '#0080005c',
                stroke: '#0080005c',
              })
            }
          }

        });

        this.canvas.renderAll();
      })

    }
  }
}
